// extracted by mini-css-extract-plugin
module.exports = {"all":"Template_all__2vFg9"};